import React from 'react';
import c from 'classnames';
import ToggleButton, { Props as ToggleButtonProps } from '../../../../ToggleButton';
import s from './ActionBarToggleButton.scss';

interface Props extends ToggleButtonProps {
  dataHook?: string;
}

/**
 * Provides our `ToggleButton` with some additional ActionBar specific styling.
 */
const ActionBarToggleButton: React.FC<Props> = ({
  className,
  activated,
  children,
  icon: Icon,
  ...rest
}) => (
  <ToggleButton className={c(s['root'], className)} icon={Icon} activated={activated} {...rest} />
);
ActionBarToggleButton.displayName = 'ActionBarToggleButton';

export default ActionBarToggleButton;
